export default __webpack_public_path__ + "static/media/avatar_105.677a2bd0.png";